import React, { useState } from "react";
import AvailableEvents from "../../AvailableEvents";
import FontAwesome from "react-fontawesome";

const SidebarJobs = ({ jobToggle, setJobToggle }) => {
  const handleClick = () => {
    setJobToggle({
      toggleState: !jobToggle.toggleState,
      toggleClass: jobToggle.toggleState
        ? "fa fa-chevron-left"
        : "fa fa-chevron-right",
    });
  };
  return (
    <>
      <span
        aria-hidden="true"
        className={jobToggle.toggleClass}
        style={{
          fontSize: "24px",
          padding: "10px",
          position: "relative",
          right: "0",
          backgroundColor: "#f1f1f2",
        }}
        onClick={handleClick}
      ></span>

      {jobToggle.toggleState ? <AvailableEvents /> : <></>}
    </>
  );
};

export default SidebarJobs;
